import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TripTypesFieldComponent } from "src/app/pages/register-user/shared/components";

@Component({
  selector: 'app-form-step-3',
  standalone: true,
  imports: [
    TripTypesFieldComponent
],
  templateUrl: './form-step-3.component.html',
  styleUrls: ['./form-step-3.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormStep3Component {
  public form = input<FormGroup>();
}
